import * as React from "react";
import { useEffect } from "react";

/**
 * The page properties
 */
export interface IPageProps {
  /**
   * The page title
   */
  title: string;
}

/**
 * The page component.
 *
 * @param props - the page props.
 * @returns - the component.
 */
export const Page: React.FC<IPageProps> = (props) => {
  useEffect(() => {
    document.title = props.title || "";
  }, [props.title]);

  return <>{props.children}</>;
};
